import React from 'react';

export const ViewDriver = React.lazy(() => import('./ViewDriver'));
export const NewDriver = React.lazy(() => import('./NewDriver'));
export const EditDriver = React.lazy(() => import('./EditDriver'));
